export const headersFiscalContrato = [
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 3, key: 'status' },
  { text: 'Tipo', width: 9, key: 'tipoFiscal' },
  { text: 'Data Início', width: 8, key: 'dataInicio' },
  { text: 'Data Término', width: 8, key: 'dataTermino' },
  { text: 'Nome', width: 45, key: 'nomeFiscal' },
];

export const fiscalData = [
  {
    offCanvas: '',
    fiscalId: 1,
    status: 'Ativo',
    tipoFiscal: 'Técnico',
    dataInicio: '01/01/2024',
    dataFim: '31/12/2024',
    nomeFiscal: 'Maria Souza da Silva',
  },
  {
    offCanvas: '',
    fiscalId: 2,
    status: 'Inativo',
    tipoFiscal: 'Administrativo',
    dataInicio: '15/02/2023',
    dataFim: '15/02/2024',
    nomeFiscal: 'João Carlos Ferreira',
  },
  {
    offCanvas: '',
    fiscalId: 3,
    status: 'Ativo',
    tipoFiscal: 'Técnico',
    dataInicio: '10/03/2024',
    dataFim: '10/09/2024',
    nomeFiscal: 'Ana Paula Menezes',
  },
];

export const valoresExibidosFiscalContrato: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Data de Registro',
  dataAtualizacao: 'Última Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  dataUltimaAtualizacao: 'Última Atualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  usuarioRegistro: 'Responsável pelo Registro',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  observacoes: 'Observações',

  // Fase
  status: 'Status',
  fiscal: 'Fiscal',
  tipoFiscal: 'Tipo de Fiscal',
  dataInicio: 'Data de Início',
  dataTermino: 'Data de Término',
  documentoSei: 'Documento SEI',
  link: 'Link',

  //Separadores
  separador: '',
  separadorLog: '',
  separadorFiscal: '',
};

export const fieldObjectProaq = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
  'responsavel.nomeCompleto',
  'proaq.id',
  'proaqResponsavel.responsavel',
  'produtoDAF.produtoFarmaceutico',
  'denominacaoGenerica.denominacaoGenerica',
  'KitProdutoDAF.nomeKit',
];
